// extracted by mini-css-extract-plugin
export default {"container":"TabItem_container__KOthw","isCurrent":"TabItem_isCurrent__ufJYX","iconContainer":"TabItem_iconContainer__IhLWs","text":"TabItem_text__Gx9UI"};